<script setup lang="ts">




defineComponent({
  name: "Perks",
});

defineProps({
  perkClass: {type: String, required: false}
})


const iconComponents = computed(() => {
  return iconsCredit.map((icon) => iconComponent(icon));
});


</script>
<template>
  <section
    class="bg-gray-1 mb-16 lg:mb-20 px-8 relative perks"
    :class="perkClass"
  >
    <div class="flex flex-col-reverse md:flex-row md:justify-center items-center md:gap-20">
      <div class="yellowBox w-full mt-2 max-w-[300px]">
        <template v-for="(el, index) in iconComponents" :key="index">
          
          <div class="flex justify-center md:justify-start items-center py-6 " :class="index < iconComponents.length - 1 ? 'border-b border-less-light-yellow':''"> 
            <component :is="el.icon"></component>
            <div class="pl-3 text-left">
              <h4 class="font-semibold" v-html="el.text"></h4>
              <small class="hidden md:block" v-html="el.subtext"></small>
            </div>
          </div>
        </template>
      </div>
      
      <div class="flex justify-center mb-2 md:mb-0 max-w-[250px]"> 
        <img
          width="710"  
          height="323"
          loading="lazy"
          class="mx-auto max-w-full"
          alt="Prestito Personale - Recensioni TrustPilot: 4.5 su 5 basato su più di 35000 recensioni"
          title="TrustPilot 2025"
          src="/images/static/TrustPilot_Cofidis_2025_10.webp"
        />
      </div>
    </div>

  </section>
</template>